import { c as _c } from "react/compiler-runtime";
import { ContextCurrencyFragment, getCurrencyKey, readCurrencyFragment } from "@opensea/app-kit";
import { graphql, useQuery } from "@opensea/graphql";
import { FlexColumn, List, TextBody, withSuspense } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { CurrencyItem } from "../CurrencyItem";
import { CurrencySkeletons } from "./CurrencySkeletons";
const query = graphql(`
    query PrioritizedCurrencies($chains: [ChainIdentifier!]) {
      prioritizedCurrencies(chains: $chains) {
        ...ContextCurrency
      }
    }
  `, [ContextCurrencyFragment]);
export const PrioritizedCurrencies = withSuspense(({
  selectedChain,
  onSelectCurrency
}) => {
  const t = useTranslations("wallet.PrioritizedCurrencies");
  const [{
    data
  }] = useQuery({
    query,
    variables: {
      chains: selectedChain !== "all" ? [selectedChain] : undefined
    }
  });
  const currencies = data?.prioritizedCurrencies.map(currency => readCurrencyFragment(currency));
  if (!currencies || currencies.length === 0) {
    return null;
  }
  return <FlexColumn className="gap-2.5">
        <TextBody>{t("popularTokens")}</TextBody>
        <List className="-mx-2 bg-transparent" showBorder={false}>
          {currencies.map(currency => {
        return <CurrencyItem currency={currency} key={getCurrencyKey(currency)} onClick={() => onSelectCurrency(currency)} />;
      })}
        </List>
      </FlexColumn>;
}, <PrioritizedCurrenciesSkeleton />);
function PrioritizedCurrenciesSkeleton() {
  const $ = _c(7);
  const t = useTranslations("wallet.PrioritizedCurrencies");
  let t0;
  if ($[0] !== t) {
    t0 = t("popularTokens");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TextBody>{t0}</TextBody>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <List className="-mx-2 bg-transparent" showBorder={false}><CurrencySkeletons count={3} /></List>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <FlexColumn className="gap-2.5">{t1}{t2}</FlexColumn>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}